import Layout from '@/layout'
const priceRouter = {
  path: '/price',
  component: Layout,
  name: 'price',
  meta: {
    title: '报价管理',
    icon: 'el-icon-coin',
    roles: ['root', 'market', 'business']
  },
  children: [

    {
      path: 'ppf',
      name: 'PricePPF',
      component: () => import('@/views/minip/price/ppf'),
      meta: { title: '隐形车衣报价', icon: 'el-icon-refrigerator', roles: ['root', 'market', 'business'], noCache: false }
    },
    {
      path: 'ppf_args',
      name: 'ArgsNameTable',
      component: () => import('@/views/minip/price/ppf_args'),
      meta: { title: '隐形车衣部位参数', icon: 'el-icon-set-up', roles: ['root', 'market', 'business'], noCache: false }
    },
    {
      path: 'ppf_create',
      name: 'PricePPFCreate',
      component: () => import('@/views/minip/price/create_ppf'),
      meta: { title: '新增隐形车衣报价', icon: 'el-icon-refrigerator', roles: ['root', 'market', 'business'] },
      hidden: true
    },
    {
      path: 'windowflim',
      name: 'PriceWindowFilm',
      component: () => import('@/views/minip/price/windowfilm'),
      meta: { title: '防爆隔热膜报价', icon: 'el-icon-sunrise-1', roles: ['root', 'market', 'business'], noCache: false }
    },
    {
      path: 'buildingfilm',
      name: 'PriceBuildingFilm',
      component: () => import('@/views/minip/price/buildingfilm'),
      meta: { title: '建筑膜报价', icon: 'el-icon-picture-outline', roles: ['root', 'market', 'business'], noCache: false }
    },
    {
      path: 'windowfilm_create',
      name: 'PriceWfCreate',
      component: () => import('@/views/minip/price/create_windowfilm'),
      meta: { title: '新增隔热膜报价', icon: 'el-icon-refrigerator', roles: ['root', 'market', 'business'] },
      hidden: true
    },
    {
      path: 'windowfilm_batch',
      name: 'PriceWfBatch',
      component: () => import('@/views/minip/price/windowfilm_batch'),
      meta: { title: '批量生成隔热膜报价', icon: 'el-icon-sunrise', roles: ['root', 'market', 'business'] },
      hidden: true
    },
    {
      path: 'batch_tasks',
      name: 'PriceBatchTasks',
      component: () => import('@/views/minip/price/batch_tasks'),
      meta: { title: '批量报价任务', icon: 'el-icon-s-data', roles: ['root', 'market', 'business'], noCache: false }
    }
  ]
}
export default priceRouter
